import { computed, defineComponent, inject, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import html_iway from "./template.iway.html?raw";
import Markdown from "../../Shared/Markdown";
import { orderServiceKey } from "../../../infrastructure/gfo_api/order_service";
import { priceFormatterKey } from "../../../infrastructure/price_formatter";

const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("iway" == app_theme) {
  html = html_iway;
} else if ("lic" == app_theme) {
  html = html_iway;
} else if ("sak" == app_theme) {
  html = html_iway;
}

export default defineComponent({
  template: html,
  components: { Markdown },
  props: {
    className: {
      type: String,
      default: "",
    },
  },
  setup() {
    // injections
    const { t } = useI18n();
    const orderService = inject(orderServiceKey);
    const priceFormatter = inject(priceFormatterKey);

    // variables and computed
    const installationWanted = ref(false);
    const productId: number = 7;
    const optionVariants = computed(() => {
      return (
        orderService?.availableVariants?.value?.filter(
          (v) => v.product_id == productId,
        ) ?? []
      );
    });
    const hasSingleVariant = computed(() => optionVariants.value.length == 1);
    const hasMultipleVariants = computed(
      () => optionVariants.value.length > 1,
    );
    const vatType = computed(() => {
      return orderService?.currentVatType.value;
    });

    // methods
    const isInCart = (variantId: number) => {
      return (
        orderService?.currentItems?.value?.some(
          (it) => it.product_variant_id == variantId,
        ) ?? false
      );
    };

    const toggleVariant = async (variantId: number) => {
      if (!isInCart(variantId)) {
        await orderService?.addToCart(variantId, "", 1);
      } else {
        await orderService?.removeFromCart(variantId, "", 1);
      }
    };

    const installationWantedToggle = async () => {
      if (false == installationWanted.value) {
        const toRemove =
          orderService?.currentItems?.value?.filter(
            (it) => it.product_id == productId,
          ) ?? [];
        for (let i = 0; i < toRemove.length; i++) {
          await orderService?.removeFromCart(
            toRemove[i].product_variant_id,
            "",
            toRemove[i].qty,
          );
        }
      } else if (hasSingleVariant.value) {
        await orderService?.addToCart(optionVariants.value[0].id, "", 1);
      }
    };

    onMounted(() => {
      const hasInstallation =
        orderService?.currentItems?.value?.filter(
          (it) => it.product_id == productId,
        ).length ?? 0;
      if (0 < hasInstallation) {
        installationWanted.value = true;
      }
    });

    return {
      t,
      installationWanted,
      installationWantedToggle,
      optionVariants,
      hasSingleVariant,
      hasMultipleVariants,
      isInCart,
      toggleVariant,
      priceFormatter,
      vatType,
    };
  },
} as any);
